import { configureStore } from '@reduxjs/toolkit';
import type { ThunkAction } from '@reduxjs/toolkit';
import type { ActionFromReducersMapObject, CombinedState, Reducer, StateFromReducersMapObject } from 'redux';

import { baseRTKApi } from 'shared/api/baseApi';

import { reducers } from './combineReducer';
import { persistedStoreMiddleware } from './persistedStoreMiddleware';

export type AppStore = ReturnType<typeof initializeStore>;
export type AppDispatch = AppStore['dispatch'];
export type GlobalState = ReturnType<
  Reducer<CombinedState<StateFromReducersMapObject<typeof reducers>>, ActionFromReducersMapObject<typeof reducers>>
>;
export type ThunkResult<R> = ThunkAction<R, GlobalState, undefined, ActionFromReducersMapObject<typeof reducers>>;

export const initializeStore = (initialState?: GlobalState) =>
  configureStore({
    devTools: true,
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(baseRTKApi.middleware).concat(persistedStoreMiddleware),
    ...(initialState && { preloadedState: initialState }),
  });

export const getOrCreateStore = (initialState?: GlobalState): AppStore => {
  const isServer = typeof window === 'undefined';

  if (isServer) {
    return initializeStore(initialState);
  }

  if (!window.__NEXT_REDUX_STORE__) {
    window.__NEXT_REDUX_STORE__ = initializeStore(initialState);
  }

  return window.__NEXT_REDUX_STORE__;
};
